(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rb-fitting-kit-product"]) return;
  try {
    
document.addEventListener('change',function(event){
 if(!event.target.matches('[data-rb-kit-variant]'))return;
 const url=new URL(window.location.href);url.searchParams.set('variant',event.target.value);window.location.assign(url.href);
});
document.addEventListener('click',function(event){
 const link=event.target.closest('[data-rb-kit-image]');if(!link)return;
 const root=link.closest('.rb-kit'),hero=root.querySelector('.rb-kit__hero'),img=hero&&hero.querySelector('img');if(!img)return;
 event.preventDefault();img.removeAttribute('srcset');img.src=link.dataset.rbKitImage;img.alt=link.dataset.rbKitAlt;hero.href=link.href;
});
document.addEventListener('change',function(event){
 if(!event.target.matches('[data-package-select]'))return;
 const card=event.target.closest('[data-kit-package]'),option=event.target.selectedOptions[0],button=card.querySelector('[data-package-add]'),img=card.querySelector('.rb-kit__package-image');
 card.querySelector('[data-package-price]').textContent=option.dataset.price;
 const compare=card.querySelector('[data-package-compare]');compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;
 card.querySelector('[data-package-link]').href=option.dataset.url;
 button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldOut:button.dataset.addLabel;
 if(img){img.removeAttribute('srcset');img.src=option.dataset.image;img.alt=option.dataset.alt;}
});

  } catch(e) { console.error(e); }
})();
})();
